import { configureStore } from '@reduxjs/toolkit';

import railStationReducer from '../features/railStations/railStationSlice'
import railRouteReducer from '../features/railRoutes/railRouteSlice'
import authReducer from '../features/auth/authSlice'
import journeyReducer from '../features/journeys/journeySlice'
import tripReducer from '../features/trips/tripSlice'
import subscriptionReducer from '../features/subscription/subscriptionSlice'
import mediaReducer from '../features/media/mediaSlice'
import creatorReducer from '../features/creator/creatorSlice'
import userReportReducer from '../features/userReports/userReportSlice'
import publicProfileReducer from '../features/publicProfile/publicProfileSlice'

export const store = configureStore({
  reducer: {
    auth: authReducer,
    stations: railStationReducer,
    routes: railRouteReducer,
    journeys: journeyReducer,
    trips: tripReducer,
    subscription: subscriptionReducer,
    media: mediaReducer,
    creator: creatorReducer,
    userReports: userReportReducer,
    publicProfiles: publicProfileReducer,
  },
});
